import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconGift({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path
					id="a"
					d="M11.863 0c.547 0 .745.194.746.732 0 .941-.007 1.882.004 2.823.003.312-.114.517-.39.668-.08.044-.13.207-.13.315-.008 1.769-.006 3.538-.006 5.307 0 .735-.152.887-.877.887H6.816V0zM5.797.001v10.715c-.1.006-.189.016-.278.016h-4.25c-.528 0-.726-.195-.727-.72 0-1.818-.002-3.636.003-5.455 0-.185-.036-.29-.219-.403-.153-.094-.302-.33-.307-.508C-.01 2.626.001 1.603.007.58.01.256.24.007.566.005 2.299-.003 4.032.001 5.797.001"
				/>
				<path
					id="c"
					d="M5.438 2.214c.458.58.655 1.255.701 1.985.063.994-.537 2.793-1.112 3.792-.5-.336-1.009-.653-1.49-1.007-.767-.563-1.455-1.21-1.93-2.053-.332-.588-.507-1.216-.327-1.887.26-.968.955-1.525 1.876-1.733.924-.208 1.695.159 2.282.903m5.324 2.324c.302.368.386.79.26 1.24-.297 1.064-1.07 1.637-2.072 1.956-.996.318-2.019.275-3.042.212-.045-.003-.088-.026-.156-.047.507-1.44 1.045-2.836 2.398-3.713.88-.57 1.97-.429 2.612.352M2.777 3.73c.026.335.102.701.268.984.583.988 1.214 1.946 1.828 2.914.023.036.066.06.145.128-.003-1.215.133-2.382-.164-3.525-.137-.527-.398-.993-.896-1.258-.489-.26-1.224.198-1.181.757m5.88 1.549c-.904.399-1.531 1.096-2.131 1.822l-.359.437-.18.218c.512-.165 1.034-.304 1.533-.5.48-.191.964-.4 1.392-.68.293-.191.534-.493.724-.79.215-.337.117-.53-.292-.602a1.26 1.26 0 0 0-.687.095"
				/>
			</defs>
			<g fill="none" fillRule="evenodd" transform="translate(6 2)">
				<path
					fill="#CD0400"
					d="M12.209 9.244c.548 0 .745.194.746.733 0 .94-.007 1.881.004 2.822.003.312-.114.517-.39.668-.079.044-.13.207-.13.315-.008 1.769-.006 3.538-.006 5.307 0 .735-.152.887-.877.887H7.162V9.244zm-6.066.001V19.96c-.1.006-.189.016-.278.016h-4.25c-.527 0-.726-.195-.726-.72Q.886 16.53.89 13.802c0-.185-.036-.29-.218-.403-.154-.094-.303-.33-.308-.508-.028-1.02-.018-2.043-.011-3.065.002-.325.232-.574.558-.576 1.733-.008 3.466-.004 5.231-.004"
				/>
				<path
					fill="#FFF"
					d="M11.896 8.931c.547 0 .745.194.746.732 0 .94-.007 1.882.004 2.822.003.313-.114.518-.39.669-.08.043-.13.206-.13.315-.008 1.768-.006 3.537-.006 5.306 0 .735-.152.888-.877.888H6.849V8.931zm-6.066 0v10.715c-.1.007-.189.016-.278.016q-2.126.002-4.25 0c-.527 0-.726-.195-.727-.719 0-1.818-.002-3.637.003-5.455 0-.185-.036-.291-.219-.403-.153-.095-.302-.33-.307-.508C.023 11.556.034 10.534.04 9.512c.003-.325.233-.574.559-.576 1.733-.009 3.466-.004 5.231-.004"
				/>
				<g transform="translate(.033 8.93)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<use xlinkHref="#a" fill="#FFF" />
					<path
						fill="#CD0400"
						d="m17.074 4.956-4.308.637-.888.131-4.307.637-.888.13-4.307.638-.888.13-4.307.637-.203.272 4.784-.707.411-.06 4.785-.708.41-.06 4.785-.708.41-.06 4.785-.708M13.871 4.115l-3.485.515-1.71.253-3.485.515-1.71.252-3.486.515-1.71.253-.202.272L.27 6.367l3.008-.445L5.465 5.6l3.008-.445 2.187-.323 3.008-.445M16.327 4.41l-3.008.444-2.187.323-3.008.445-2.187.323-3.008.445-2.187.323-3.009.444-.203.272 3.486-.515 1.71-.253 3.485-.515 1.71-.253 3.486-.515 1.709-.252 3.486-.516M17.41 5.564l-4.785.707-.411.061-4.784.707-.411.06-4.785.708-.41.06-4.785.708-.41.06-.204.272.888-.13 4.307-.638.889-.131 4.307-.636.888-.132 4.307-.636.888-.132 4.307-.636M17.41 6.18l-4.785.707-.411.061-4.784.707-.411.06-4.785.708-.41.06-4.785.708-.41.06-.204.272.888-.13 4.307-.638.889-.131 4.307-.636.888-.132 4.307-.636.888-.132 4.307-.636M17.41 6.796l-4.785.707-.411.061-4.784.707-.411.06-4.785.708-.41.06-4.785.708-.41.06-.204.272.888-.13L1.62 9.37l.889-.131 4.307-.636.888-.132 4.307-.636.888-.132 4.307-.636M17.41 7.423l-4.785.707-.411.061-4.784.707-.411.06-4.785.708-.41.06-4.785.708-.41.06-.204.272.888-.13 4.307-.638.889-.131 4.307-.636.888-.132 4.307-.636.888-.132 4.307-.636M17.41 8.05l-4.785.707-.411.061-4.784.707-.411.06-4.785.708-.41.06-4.785.708-.41.06-.204.272.888-.13 4.307-.638.889-.13 4.307-.637.888-.132 4.307-.636.888-.132 4.307-.636M17.41 8.677l-4.785.707-.411.061-4.784.707-.411.061-4.785.707-.41.06-4.785.708-.41.06-.204.272.888-.13 4.307-.637.889-.132 4.307-.636.888-.132 4.307-.636.888-.131 4.307-.637M17.41 9.304l-4.785.707-.411.061-4.784.708-.411.06-4.785.707-.41.061-4.785.707-.41.06-.204.273.888-.132 4.307-.636.889-.132 4.307-.636.888-.131 4.307-.637.888-.131 4.307-.637"
						mask="url(#b)"
					/>
				</g>
				<use xlinkHref="#c" fill="#FFF" transform="rotate(-16 6.143 4.622)" />
			</g>
		</svg>
	);
}
